import { queryClient } from 'App';

export default async (data) => {
  const { patient_id } = data;

  queryClient.invalidateQueries(['customFormResponse', patient_id]);
};
